/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourceTag
 */
export interface SourceTag {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the SourceTag interface.
 */
export function instanceOfSourceTag(value: object): value is SourceTag {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SourceTagFromJSON(json: any): SourceTag {
    return SourceTagFromJSONTyped(json, false);
}

export function SourceTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceTag {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function SourceTagToJSON(json: any): SourceTag {
    return SourceTagToJSONTyped(json, false);
}

export function SourceTagToJSONTyped(value?: SourceTag | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

